// React and related imports
import React from 'react';

// Flowbite components
import { Select } from 'flowbite-react';

// i18n hooks
import { useTranslation } from 'react-i18next';

// Enums
import { DashboardUserRole } from '../../common/enums/DashboardUserRole';

interface RoleSelectProps {
  id: string;
  value: DashboardUserRole;
  onChange: (role: DashboardUserRole) => void;
  disabled?: boolean;
  /** Accessible name when there is no visible label, e.g. "Role for Amina". */
  ariaLabel?: string;
  sizing?: 'sm' | 'md';
}

/** The four dashboard roles, labelled in the current language. */
export const RoleSelect: React.FC<RoleSelectProps> = ({
  id,
  value,
  onChange,
  disabled,
  ariaLabel,
  sizing = 'md',
}) => {
  const { t } = useTranslation();

  return (
    <Select
      id={id}
      sizing={sizing}
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value as DashboardUserRole)}
    >
      {Object.values(DashboardUserRole).map((role) => (
        <option key={role} value={role}>
          {t(`roles.${role}`)}
        </option>
      ))}
    </Select>
  );
};
